/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CloudConnectorUserModule
 */

import { IAzureServicePrincipalCredentials } from 'generated-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

export class AzureServicePrincipalCredentialsConfigItem
    extends MessageItem<IAzureServicePrincipalCredentials> {
    /**
     * @constructor
     */
    constructor(args = {}) {
        const extendedArgs = {
            objectType: 'AzureServicePrincipalCredentials',
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    public isValid(): boolean {
        return this.canFlatten();
    }

    /** @override */
    public canFlatten(): boolean {
        return Boolean(this.config.application_id);
    }

    /**
     * Deletes configured fields.
     */
    public clearFields(): void {
        delete this.config.application_id;
        delete this.config.authentication_token;
        delete this.config.tenant_id;
    }
}
